<template>
    <section class="module-alternating">
        <div class="container">
            <AbBox v-for="(item, index) in module.items" :data="item" :key="index" :index="index"></AbBox>
        </div>
    </section>
</template>

<script>
import AbBox from "../boxes/AbBox.vue";

export default {
    name: "ModuleAlternating",
    components: {
        AbBox
    },
    props: {
        module: {
            type: Object,
            required: true,
        }
    }
};
</script>